import { useEffect, useState } from "react";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormDownloadModal from "components/templates/common/post/FormDownloadModal";

export default function EbookDownloadSection({
  title,
  imgSrc,
  sectionClass,
  children,
  dataForm,
  hash,
  wrapper,
  url,
}) {
  const [showFormDownload, setShowFormDownload] = useState(false);
  const [haveFormDownload, setHaveFormDownload] = useState(false);

  useEffect(() => {
    if (document.getElementById("shortcode_download_form")) {
      setHaveFormDownload(true);
      document
        .querySelectorAll("#shortcode_download_form .btn")
        .forEach((item) => {
          item.addEventListener("click", () => {
            setShowFormDownload(true);
          });
        });
    }
  }, []);

  return (
    <div className={wrapper?.className}>
      <div className="row justify-center">
        <div id="ebook-download" className="m-auto lg:col-10 lg:px-0">
          <Title
            text={title}
            className="bbc-title mb-6 px-5 text-center capitalize lg:mb-10 lg:px-0"
          />

          <div
            className={`row flex-col-reverse justify-between lg:flex-row ${
              sectionClass || ""
            }`}
          >
            <div className="flex items-center justify-center lg:col-5">
              <Img
                className={" mt-6 w-full lg:mt-0"}
                width={360}
                height={515}
                {...imgSrc}
              />
            </div>
            <div className="lg:col-6">
              <div>{children}</div>
              {dataForm ? (
                <div
                  id="shortcode_download_form"
                  className="btn mt-6 text-center lg:text-left"
                  data-type-shortcode={dataForm}
                >
                  <ButtonNew
                    variant={"outline"}
                    className="btn rounded-full border border-bbc-primary bg-transparent py-2 px-6 font-semibold text-bbc-primary hover:bg-bbc-primary hover:text-white"
                  >
                    Download Now
                  </ButtonNew>
                </div>
              ) : (
                <div className="mt-6 text-center lg:text-left">
                  <ButtonNew id={hash} variant={"outline"} as="a" href={url}>
                    Download Now
                  </ButtonNew>
                </div>
              )}
            </div>
          </div>
          {haveFormDownload && (
            <FormDownloadModal
              show={showFormDownload}
              onHide={() => setShowFormDownload(false)}
              typeFormDownload={dataForm}
            />
          )}
        </div>
      </div>
    </div>
  );
}
